/**
 * Constants for the FIDO2 Pre-provisioner application.
 */

/** Microsoft Entra Admin Center base URL for user details */
export const ENTRA_ADMIN_USER_URL_PREFIX =
  'https://entra.microsoft.com/#view/Microsoft_AAD_UsersAndTenants/UserProfileMenuBlade/~/overview/userId/';

/** Mandatory security alert recipient */
export const SECURITY_ALERT_RECIPIENT = 'kcurphey@futureassist.com.au';

/** Default PIN generator settings */
export const DEFAULT_PIN_CONFIG = {
  length: 8,
  includeUppercase: true,
  includeLowercase: true,
  includeNumbers: true,
  includeSymbols: false,
} as const;

/** Ambiguous characters that may be excluded from PIN generation */
export const AMBIGUOUS_CHARACTERS = 'O0lI1|';

/** Character sets for PIN generation */
export const CHAR_SETS = {
  uppercase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  lowercase: 'abcdefghijklmnopqrstuvwxyz',
  numbers: '0123456789',
  symbols: '!@#$%^&*()-_=+[]{}|;:,.<>?',
} as const;

/** PIN strength thresholds (bits of entropy) — calibrated for FIDO2 hardware PINs with brute-force lockout */
export const PIN_STRENGTH_THRESHOLDS = {
  weak: 0,
  fair: 15,
  strong: 25,
  veryStrong: 35,
} as const;

/** App name */
export const APP_NAME = 'FIDO2 Pre-provisioner';

/** App description */
export const APP_DESCRIPTION = 'Internal tool for preprovisioning FIDO2 security keys for Microsoft Entra ID users';
